import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage, defineMessages } from 'react-intl';
import { Button } from 'ui-components/components/button';

import style from './style.module.less';

const messages = defineMessages({
  selectedOrders: {
    description: 'selected.orders.message',
    defaultMessage: '{selectedCount} orders are selected. <b>Select all {totalCount} orders in {gridStatus}.</b>',
    id: 'LlDY5v',
  },
  allSelected: {
    description: 'select.all.selected',
    defaultMessage: 'All {totalCount} selected. <b>Clear selection.</b>',
    id: 'EWbLMx',
  },
});

const SelectAllBannerComponent = ({ selectedCount, totalCount, toggleAreAllSelected, areAllSelected, gridStatusText, className = '' }) => {
  if (areAllSelected) {
    return (
      <span className={classnames(style.banner, className)}>
        <FormattedMessage
          {...messages.allSelected}
          values={{
            totalCount,
            b: (chunks) => (
              <Button className={style['select-button']} onClick={toggleAreAllSelected} theme='link'>
                {chunks}
              </Button>
            ),
          }}
        />
      </span>
    );
  }

  return (
    <span className={classnames(style.banner, className)}>
      <FormattedMessage
        {...messages.selectedOrders}
        values={{
          selectedCount,
          totalCount,
          gridStatus: gridStatusText,
          b: (chunks) => (
            <Button className={style['select-button']} onClick={toggleAreAllSelected} theme='link'>
              {chunks}
            </Button>
          ),
        }}
      />
    </span>
  );
};

SelectAllBannerComponent.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  toggleAreAllSelected: PropTypes.func.isRequired,
  areAllSelected: PropTypes.bool.isRequired,
  gridStatusText: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default SelectAllBannerComponent;
